import React from "react";

import { DEFAULT_CARD_HEIGHT, SECTION } from "config/constants";
import SectionStreamWrapper from "stream/containers/SectionStreamWrapper";
import Stream from "stream/containers/Stream";
import EventCard from "cards/containers/EventCard";
import EventsSectionStreamHeader from "stream/components/EventsSectionStreamHeader";

export default function EventsSectionStream(props) {
  return (
    <>
      <EventsSectionStreamHeader />
      <SectionStreamWrapper {...props} slug={SECTION.EVENTS.slug}>
        {({ streamParams }) => {
          return (
            <>
              <Stream
                {...streamParams}
                defaultCardHeight={DEFAULT_CARD_HEIGHT.SUMMARY_CARD}
                contentComponent={EventCard}
                onlyShowTitleForA11y={true}
                disableAnalytics={true}
                disableUrlUpdating={true}
                disableAds={true}
              />
            </>
          );
        }}
      </SectionStreamWrapper>
    </>
  );
}
